import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

const VaccinationOverdueModalContent = ({ vaccinationOverdue }) => {
  const overdueKeys = vaccinationOverdue?.data?.overdue_response || [];
  const filteredKeys = overdueKeys.filter((item) => item.is_overdue);

  return (
    <div className="bg-white rounded-[20px]">
      {filteredKeys.length > 0 ? (
        <ul className="list-disc list-inside text-sm text-black mt-5">
          {filteredKeys.map((item) => (
            <li key={item.unique_dose_key}>{item.unique_dose_key}</li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500">No overdue vaccinations.</p>
      )}
    </div>
  );
};

const VaccinationOverdueModal = () => {
  const { setInvisible } = useModalActions("VACCINATION_OVERDUE_MODAL");
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("CUSTOMER_PROFILE", "id");
  const { routeState } = useRouteInfo(routeId);
  const { vaccinationOverdue } = routeState.state as ICustomerProfileState;

  return (
    <ModalPrompt
      modalId="VACCINATION_OVERDUE_MODAL"
      showIcon={false}
      contentOverflow={true}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-md sm:p-6"
      button={{
        primaryButtonText: "OK",
        secondaryButtonText: "",
        primaryButtonClassname:
          "px-6 cursor-pointer py-[9px] bg-red-500 hover rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex",
        primaryCallback: () => {
          setInvisible();
        },
      }}
      title="Overdue Vaccines"
      content={<VaccinationOverdueModalContent vaccinationOverdue={vaccinationOverdue} />}
    />
  );
};

export default VaccinationOverdueModal;
